// extracted by mini-css-extract-plugin
export var container = "_n7-0";
export var dotAnimation = "_n7-2";
export var dotsLoading = "_n7-1";